<template>
  <div style="display: none"></div>
</template>

<script>
import Cookies from "js-cookie";
import api from "@/api";
import { gioAdsTracking } from "@/utilities/tools";
import { getToken } from "@/utilities/userToken";
export default {
  name: "EmergencyMessageAlert",
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.showMessage();
    },
    async showMessage() {
      // 维护弹窗：popupMessageType = 1，无频控，有维护信息即弹出
      const isMaintain = await this.fetchPopup(1, false);
      if (isMaintain) {
        return;
      }

      // 普通弹窗：popupMessageType = 2，每天显示一次（cookie 频控）
      await this.fetchPopup(2, true);
    },
    // 统一走 GetStationPopupInfo 拉取弹窗信息（对齐小程序/PC 端逻辑）
    // popupMessageType: 1 维护弹窗 / 2 普通弹窗；useCookie: 是否启用每天一次频控
    // 图片版：popupType === '图片' 展示 pictureUrl，点击跳 jumpLink
    async fetchPopup(popupMessageType, useCookie) {
      try {
        const { success, data } = await api.page.getStationPopupInfo({
          userName: getToken() || "",
          source: "mobile",
          popupMessageType
        });
        if (!success || !data) {
          return false;
        }

        const isImage = data.popupType === "图片";
        const content = isImage ? data.pictureUrl : data.textContent;
        if (!content) {
          return false;
        }

        if (useCookie) {
          const isPopuped = Cookies.get("rcclinformModal", { path: "/" });
          if (isPopuped && isPopuped.length > 0) {
            return false;
          }
        }

        const jumpLink = data.isSetJump && data.jumpLink ? data.jumpLink : "";
        if (isImage) {
          // 图片版：正文为 <img>，点击图片跳转（$alert 正文是 v-html，Alert.vue 已有 img 自适应样式）
          this.$alert.show(
            `<img src="${data.pictureUrl}" style="display:block;width:100%;cursor:pointer;" onclick="window.open('${jumpLink}')" />`,
            {
              title: '',
              hideTitle: true,
              confirmCallBack: () => {
                gioAdsTracking({
                  "adsType": "pp"
                })
              }
            }
          );
        } else {
          this.$alert.show(data.textContent, {
            title:popupMessageType === 2 ? "" :'维护通知',
            confirmCallBack: () => {
              gioAdsTracking({
                "adsType": "pp"
              })
            }
          });
        }

        if (useCookie) {
          Cookies.set("rcclinformModal", data.id, { expires: 1 });
        }
        return true;
      } catch (e) {
        // 接口异常静默处理
      }
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
</style>